import { createFileRoute } from '@tanstack/react-router';
import { PublicPriceCalculator } from '@uturn/portal/modules/price-calculator/pages/unauthenticated';
import z from 'zod';

const PriceCalculatorIdParams = z.object({
	uuid: z.string().optional(),
});

export const Route = createFileRoute('/_public/price-calculator/{-$uuid}')({
	params: {
		parse: (rawParams) => PriceCalculatorIdParams.parse(rawParams),
	},
	component: PublicPriceCalculator,
});
